import { Typography } from '@remarkable/ark-web';
import { Button, Divider, Modal } from 'src/components';

export function WelcomeToConnectForBusinessModal() {
  return (
    <Modal.Content className="flex flex-col items-center gap-20">
      <Modal.Title>
        <Typography as="h2" variant="responsive-heading-md">
          Welcome to Connect for Business
        </Typography>
      </Modal.Title>

      <Divider className="w-full" />

      <Modal.Description>
        <Typography variant="body-md">
          Your Connect for Business account is all set, and your 60-day free
          trial has begun. You now have full access to all the features in your
          plan.
        </Typography>
      </Modal.Description>
      <Modal.Close>
        <Button variant="primary">Get started</Button>
      </Modal.Close>
    </Modal.Content>
  );
}
